import React, { useEffect } from 'react';
import { Outlet } from 'react-router';
import { Loader } from '@components/atoms/Loader';
import { useData } from '@hooks/useData';
import { useGetAllSettings } from '@services/useGetAllSettings';
import { useTokenRefreshLoop } from '@hooks/useTokenRefreshLoop';

export const SiteSetup = () => {
    const { allSettings } = useData();
    const { request: requestAllSettings } = useGetAllSettings();
    const { loading } = useTokenRefreshLoop();

    // call services, if we don't have the information yet
    useEffect(() => {
        if (!allSettings) {
            requestAllSettings();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allSettings]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Loader />
            </div>
        );
    }

    return <Outlet />;
};